export const getLocationParams = (search: string) => new URLSearchParams(search);

export const getLocationQuery = (search: string, key: string) => {
  const parameters = getLocationParams(search);

  return parameters.get(key);
};
